import React from 'react';
import { useIntl } from 'react-intl';
import imgOne from '@/images/banner-properties-1.png';
import imgTwo from '@/images/banner-properties-2.png';
import imgThree from '@/images/banner-properties-3.png';
import InfoStepModal from '../InfoStepModal/InfoStepModal';

const InfoPropertiesModal = ({ isOpen, onClose, onConfirm }) => {
  const intl = useIntl();
  const steps = [
    {
      label: intl.formatMessage({ id: 'infoPropertiesModal.imgAlt1' }),
      text: intl.formatMessage({ id: 'infoPropertiesModal.text1' }),
      imgPath: imgOne,
    },
    {
      label: intl.formatMessage({ id: 'infoPropertiesModal.imgAlt2' }),
      text: intl.formatMessage({ id: 'infoPropertiesModal.text2' }),
      imgPath: imgTwo,
    },
    {
      label: intl.formatMessage({ id: 'infoPropertiesModal.imgAlt3' }),
      text: intl.formatMessage({ id: 'infoPropertiesModal.text3' }),
      imgPath: imgThree,
    },
  ];
  return (
    <InfoStepModal
      title={intl.formatMessage({ id: 'properties' })}
      textNextImg={intl.formatMessage({ id: 'infoStepModal.availableOnPlans' })}
      steps={steps}
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};

export default InfoPropertiesModal;
